import {
  any,
  arrayOf,
  bool,
  func,
  node,
  number,
  object,
  oneOf,
  oneOfType,
  string,
} from 'prop-types'
import { PureComponent } from 'react'
import { identity } from '@opallabs/lambda'
import TippyAdapter from './adapters/TippyAdapter'
import './styles.scss'

export default class PopoverBase extends PureComponent {
  static propTypes = {
    align: string,
    animation: oneOfType([string, bool]),
    className: string,
    classNameObj: object,
    content: any.isRequired,
    disabled: bool,
    edgeOffset: number,
    flip: bool,
    flipBehavior: arrayOf(string),
    forceClose: bool,
    hasCaret: bool,
    manualOpen: oneOf([true, false, undefined]),
    maxWidth: oneOfType([number, string]),
    onClose: func,
    onClosed: func,
    onMouseEnter: func,
    onOpen: func,
    onOpened: func,
    open: bool,
    popoverHandlers: object,
    position: string,
    sticky: oneOfType([bool, string]),
    style: object,
    theme: string,
    trigger: node.isRequired,
    triggerEvent: string,
    type: oneOf(['dropdown', 'lapidary_dropdown', 'popover', 'tooltip'])
      .isRequired,
  }

  static defaultProps = {
    disabled: false,
    flip: true,
    onMouseEnter: () => {},
    hasCaret: true,
    onClose: identity,
    onClosed: identity,
    onOpen: identity,
    onOpened: identity,
    position: 'bottom',
    theme: 'light',
    triggerEvent: 'click',
  }

  render() {
    return <TippyAdapter {...this.props} />
  }
}
PopoverBase.displayName = 'Kuiper: PopoverBase ← PopoverV2'
